<template>
  <div class="page">

    <!-- =======================
STEP 1 : DATE + SLOTS
======================= -->

    <div v-if="step===1" class="two-col-card">

      <!-- CALENDAR -->
      <div>
        <h3 class="section-title">Select Date</h3>

        <div class="calendar-box">

          <div class="cal-header">
            <button @click="prevMonth">‹</button>
            <h4>{{ monthName }} {{ year }}</h4>
            <button @click="nextMonth">›</button>
          </div>

          <div class="weekdays">
            <span v-for="d in days" :key="d">{{ d }}</span>
          </div>

          <div class="dates">
            <span v-for="(d,i) in calendar" :key="i" :class="[
            'date',
            d.today && 'today',
            selectedDate===d.full && 'active',
            d.disabled && 'disabled'
            ]" @click="!d.disabled && selectDate(d.full)">
              {{ d.label }}
            </span>
          </div>

        </div>
      </div>

      <!-- SLOTS -->
      <div>

        <h3 class="section-title">Select Time</h3>

        <select v-model="userTimezone" class="tz-select">
          <option v-for="tz in timezones" :key="tz" :value="tz">
            {{ tz }}
          </option>
        </select>

        <p class="sub">{{ formattedDate }}</p>

        <div v-if="loadingSlots" class="slot-loading"  style="margin-top: 2rem;">
          <i class="bx bx-loader-alt bx-spin"></i>
          <p>Loading slots...</p>
        </div>


        <div
          v-else-if="!slots.length"
          class="slot-empty"
          style="margin-top: 2rem;"
          >
         <div class="slot-empty-icon">
          <i class="bx bx-time-five"></i>
        </div>
          <p class="slot-empty-title">No Slots Available</p>
          <p class="slot-empty-sub">
          Please choose another date
          </p>
          </div>

        <div v-else class="slot-grid" style="margin-top: 2rem;">

          <button v-for="s in slots" :key="s.label" :class="['slot', selectedSlot?.label===s.label && 'active']"
            @click="selectSlot(s)">
            {{ convertToUserTZ(s.label) }}
          </button>

        </div>

      </div>

    </div>

    <!-- =======================
STEP 2 : PACKAGES
======================= -->

    <div v-if="step===2" class="center-card">

      <h2>Select Package</h2>

      <div class="pkg-grid">

        <div v-for="p in packages" :key="p.package_id"
          :class="['pkg-card', selectedPackage?.package_id===p.package_id && 'active']" @click="selectedPackage=p">
          <h4>{{ p.package_name }}</h4>
          <p class="pkg-desc">{{ p.package_desc }}</p>
          <div class="pkg-price">${{ p.package_amount }}</div>
        </div>

      </div>

      <button class="primary" :disabled="!selectedPackage" @click="step=3">
        Continue
      </button>

    </div>

    <!-- =======================
STEP 3 : FORM
======================= -->

    <div v-if="step===3" class="center-card">

      <h2>Your Information</h2>

      <div class="form">

        <input placeholder="Full Name" v-model="customer.name">
        <input placeholder="Email" v-model="customer.email">
        <input placeholder="Mobile" v-model="customer.mobile">

       <div
            class="form-field"
            v-for="f in formFields"
            :key="f.title"
          >

            <!-- Text -->
            <input
              v-if="f.type === 'Textfield'"
              type="text"
              :placeholder="f.title"
              v-model="formData[f.title]"
            />

            <!-- Email -->
            <input
              v-if="f.type === 'Email'"
              type="email"
              :placeholder="f.title"
              v-model="formData[f.title]"
            />

            <!-- Number -->
            <input
              v-if="f.type === 'Number'"
              type="number"
              :placeholder="f.title"
              v-model="formData[f.title]"
            />

            <!-- Mobile -->
            <input
              v-if="f.type === 'Mobile'"
              type="tel"
              :placeholder="f.title"
              v-model="formData[f.title]"
            />

            <!-- Textarea -->
            <textarea
              v-if="f.type === 'Textarea'"
              :placeholder="f.title"
              v-model="formData[f.title]"
            ></textarea>

            <!-- Options (Dropdown) -->
            <select
              v-if="f.type === 'Options'"
              v-model="formData[f.title]"
            >
              <option value="">Select</option>
              <option
                v-for="o in (f.options || '').split(',')"
                :key="o"
              >
                {{ o.trim() }}
              </option>
            </select>

            <!-- File -->
            <input
              v-if="f.type === 'File'"
              type="file"
              @change="e => formData[f.title] = e.target.files[0]"
            />

          </div>


        <button class="primary" :disabled="!validForm" @click="step=4">
          Continue
        </button>

      </div>

    </div>

    <!-- =======================
STEP 4 : CONFIRM
======================= -->

   <div v-if="step===4" class="center-card">

  <h2>Confirm Booking</h2>

  <div class="confirm-card">

    <div class="confirm-row">
      <span>Date</span>
      <b>{{ formattedDate }}</b>
    </div>

    <div class="confirm-row">
      <span>Time</span>
      <b>{{ convertToUserTZ(selectedSlot.label) }}</b>
    </div>

    <div class="confirm-row">
      <span>Package</span>
      <b>{{ selectedPackage.package_name }}</b>
    </div>

    <div class="confirm-row highlight">
      <span>Total Amount</span>
      <b>${{ selectedPackage.package_amount }}</b>
    </div>

  </div>

  <button class="primary" :disabled="paying" @click="startPayment">

    <span v-if="!paying">
      Pay ${{ selectedPackage.package_amount }}
    </span>

    <span v-else>
      Processing...
    </span>

  </button>

</div>


    <!-- =======================
STEP 5 : SUCCESS
======================= -->

    <div v-if="step===5" class="center-card success">

      <div class="check">✔</div>
      <h2>Booking Confirmed</h2>

    </div>
    <!-- =======================
PAYMENT METHOD MODAL
======================= -->

<div v-if="showPayPop" class="payment-overlay">

  <div class="payment-modal">

    <h3>Select Payment Method</h3>

    <div class="pay-options">

      <!-- PAYPAL -->
      <div v-if="pay_options.includes('paypal')" class="pay-card paypal" @click="selectPayment('paypal')">
        <div class="pay-logo">P</div>
        <div class="pay-info">
          <b>PayPal</b>
          <p>Pay securely using PayPal</p>
        </div>
      </div>

      <!-- STRIPE -->
      <div v-if="pay_options.includes('stripe')"  class="pay-card stripe" @click="selectPayment('stripe')">
        <div class="pay-logo">S</div>
        <div class="pay-info">
          <b>Stripe</b>
          <p>Pay using Credit / Debit Card</p>
        </div>
      </div>

    </div>

    <button class="cancel-btn" @click="showPayPop=false">
      Cancel
    </button>

  </div>

</div>
  </div>
</template>
<script setup>
  import { ref, computed, onMounted } from "vue";
  import { makeStripePayment,makePaypalPayment } from "../apis/payapis";
  
import { useToast } from "vue-toastification";

  import {
    getBookingPageDetails,
    getAvailableSlots,
    createAppointment
  } from "@/apis/bookingpublicapis";

  /* ======================
  STATE
  ====================== */

  const userTimezone = ref("");
  const timezones = ref(Intl.supportedValuesOf('timeZone'));
  const step = ref(1);
  const page_id = ref("");
  const pay_options = ref([]);
  const showPayPop = ref(false);

  const page = ref({});
  const vendor = ref({});
  const packages = ref([]);
  const slots = ref([]);

  const selectedDate = ref("");
  const selectedSlot = ref(null);
  const selectedPackage = ref(null);

  const loadingSlots = ref(false);
  const paying = ref(false);
const selectedPaymentMethod = ref("");

  function selectPayment(method) {
    selectedPaymentMethod.value = method;
    showPayPop.value = false;
    processPayment();
  }

async function processPayment() {

 paying.value = true;

 var resp = null;
  if(selectedPaymentMethod.value==="paypal"){
    resp = await makePaypalPayment(
      page.value.booking_page_cre_by,
      selectedPackage.value.package_amount
    );
  }
  else if(selectedPaymentMethod.value==="stripe"){
    resp = await makeStripePayment(
      page.value.booking_page_cre_by,
      selectedPackage.value.package_amount
    );
  }
  paying.value = false;

  if (resp?.status === 1 && resp?.url) {
    openPaymentPopup(resp.url)
  } else {
    var toast = useToast();
    toast.error(resp?.success || "Payment failed");
  }

  if (resp?.status) {
    step.value = 5;
  }
}

function openPaymentPopup(url) {

  const width = 500;
  const height = 700;

  const left = (window.innerWidth - width) / 2;
  const top = (window.innerHeight - height) / 2;

  window.open(
    url,
    "StripePayment",
    `width=${width},height=${height},top=${top},left=${left}`
  );

  window.addEventListener("message", function handler(event) {

    if (event.data === "PAYMENT_SUCCESS") {
      const currentUrl = window.location.href;
      console.log("url:",currentUrl);

      // popup.close();

      // window.removeEventListener("message", handler);

      // step.value = 5;

    }

  });
}

  /* FORM */

  const customer = ref({
    name: "",
    email: "",
    mobile: ""
  });

  const formFields = ref([]);
  const formData = ref({});

  /* ======================
  CALENDAR
  ====================== */


  const today = new Date();
  const month = ref(today.getMonth());
  const year = ref(today.getFullYear());

  const todayStr = today.toISOString().slice(0, 10);

  const maxDate = new Date();
  maxDate.setDate(maxDate.getDate() + 30);
  const maxDateStr = maxDate.toISOString().slice(0, 10);

  const days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

  const monthName = computed(() => {
    return new Date(year.value, month.value)
      .toLocaleString("en", { month: "long" });
  });

  const calendar = computed(() => {

    const first = new Date(year.value, month.value, 1).getDay();
    const total = new Date(year.value, month.value + 1, 0).getDate();

    let arr = [];

    // leading blanks
    for (let i = 0; i < first; i++) {
      arr.push({ empty: true });
    }

    for (let d = 1; d <= total; d++) {

      const full =
        `${year.value}-${String(month.value + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;

      const isPast = full < todayStr;
      const isFutureLimit = full > maxDateStr;

      arr.push({
        label: d,
        full,
        today: full === todayStr,
        disabled: isPast || isFutureLimit
      });

    }

    return arr;
  });


  const formattedDate = computed(() => {
    if (!selectedDate.value) return "";
    return new Date(selectedDate.value).toDateString();
  });

  /* ======================
  VALIDATION
  ====================== */

  const validForm = computed(() => {
    return customer.value.name &&
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(customer.value.email) &&
      /^[0-9]{10}$/.test(customer.value.mobile);
  });

  /* ======================
  LOAD PAGE
  ====================== */

  async function loadPage() {

    const resp = await getBookingPageDetails(page_id.value);

    if (!resp?.status) return;

    page.value = resp.page;
    packages.value = resp.packages || [];

    vendor.value = {
      timezone: resp.vendor.business_timezone
    };

    if (resp.form_template?.form_temp_fields) {

      const parsed = JSON.parse(resp.form_template.form_temp_fields);

      formFields.value = parsed;

      parsed.forEach(f => {
        formData.value[f.title] = "";
      });

    }

  }

  /* ======================
  DATE CLICK
  ====================== */

  async function selectDate(d) {

    selectedDate.value = d;
    selectedSlot.value = null;
    selectedPackage.value = null;

    await loadSlots();
  }

  /* ======================
  LOAD SLOTS (OLD FLOW)
  ====================== */

  async function loadSlots() {

    loadingSlots.value = true;

    const resp = await getAvailableSlots(
      page_id.value + "",
      selectedDate.value
    );

    if (resp?.status) {
      slots.value = resp.slots;
    } else {
      slots.value = [];
    }

    loadingSlots.value = false;
  }

  /* ======================
  TIMEZONE
  ====================== */

function convertToUserTZ(label) {

  if (!label) return "";

  let vendor_zone = vendor.value.timezone;
  let user_zone = userTimezone.value;

  if (vendor_zone === "Asia/Calcutta") vendor_zone = "Asia/Kolkata";
  if (user_zone === "Asia/Calcutta") user_zone = "Asia/Kolkata";

  const [start, end] = label.split(" - ");
  const base = selectedDate.value;   // ✅ IMPORTANT FIX

  const startVendor = new Date(
    new Date(`${base} ${start}`)
      .toLocaleString("en-US", { timeZone: vendor_zone })
  );

  const endVendor = new Date(
    new Date(`${base} ${end}`)
      .toLocaleString("en-US", { timeZone: vendor_zone })
  );

  const startUser = new Date(
    startVendor.toLocaleString("en-US", { timeZone: user_zone })
  );

  const endUser = new Date(
    endVendor.toLocaleString("en-US", { timeZone: user_zone })
  );

  const fmt = d =>
    d.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit"
    });

  return `${fmt(startUser)} - ${fmt(endUser)}`;
}

  /* ======================
  SLOT SELECT
  ====================== */

  function selectSlot(s) {
    selectedSlot.value = s;

    // 👇 OLD CODE BEHAVIOR
    if (!packages.value || packages.value.length === 0) {
      selectedPackage.value = {
        package_id: 0,
        package_name: "Free Booking",
        package_amount: 0
      };
      step.value = 3;   // jump to FORM
    } else {
      step.value = 2;   // show PACKAGES
    }
  }

  /* ======================
  PAYMENT
  ====================== */

  async function startPayment() {

    paying.value = true;

    const payload = {
      booking_page_id: page.value.booking_page_id,
      booking_page_title: page.value.booking_page_title,
      booking_page_cre_by: page.value.booking_page_cre_by,
      date: selectedDate.value,
      slot: selectedSlot.value.label,
      name: customer.value.name,
      email: customer.value.email,
      mobile: customer.value.mobile,
      selected_package: selectedPackage.value.package_id,
      amount: selectedPackage.value.package_amount,
      form_data: formData.value,
      pay_mode: "Online",
      payment_status: "Pending"
    };

    const resp = await createAppointment(payload);

    paying.value = false;

    if (resp?.status) {
      pay_options.value = resp?.pay_options || [];
      if(pay_options.value.length>0){
        showPayPop.value = true;
      }
      else{
        step.value = 5;
      }
    }
    else{
      var toast = useToast();
      toast.error(resp?.success+"");
    }

  }

  /* ======================
  NAV
  ====================== */

  function nextMonth() {
    month.value++;
    if (month.value > 11) { month.value = 0; year.value++; }
  }

  function prevMonth() {
    month.value--;
    if (month.value < 0) { month.value = 11; year.value--; }
  }

  /* ======================
  INIT
  ====================== */
onMounted(async () => {

  page_id.value =
    window.location.pathname.split("/")
      .filter(Boolean)
      .pop();

  userTimezone.value = Intl.DateTimeFormat().resolvedOptions().timeZone;

  await loadPage();

  selectedDate.value = todayStr;

  await loadSlots();

});

</script>



<style scoped>
  /* PAGE */

  .page {
    min-height: 100vh;
    background: #f8fafc;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Inter;
  }

  /* LAYOUTS */

  .two-col-card {
    width: 100%;
    max-width: 960px;
    background: #fff;
    padding: 28px;
    border-radius: 18px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 28px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, .12);
  }

  .center-card {
    width: 100%;
    max-width: 420px;
    background: #fff;
    padding: 30px;
    border-radius: 18px;
    text-align: center;
    box-shadow: 0 20px 60px rgba(0, 0, 0, .12);
  }

  /* TITLES */

  .section-title {
    font-size: 1rem;
    font-weight: 600;
  }

  .sub {
    font-size: .85rem;
    color: #6b7280
  }

  /* CALENDAR */

  .cal-header {
    display: flex;
    justify-content: space-between
  }

  .weekdays,
  .dates {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 8px
  }

  .date {
    aspect-ratio: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px
  }

  .date:hover {
    background: #111;
    color: #fff
  }

  .today {
    background: #eef2ff
  }

  .active {
    background: #111;
    color: #fff
  }

  /* SLOTS */

  .slot-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    margin-top: 12px
  }

  .slot {
    padding: 12px;
    border-radius: 12px;
    border: 1px solid #ddd;
    background: #fff
  }

  .slot:hover {
    background: #111;
    color: #fff
  }

  /* PACKAGES */

  .pkg-grid {
    display: grid;
    gap: 12px;
    margin: 14px 0
  }

  .pkg-card {
    padding: 14px;
    border-radius: 14px;
    border: 1px solid #ddd;
    cursor: pointer
  }

  .pkg-card.active {
    background: #111;
    color: #fff;
    border-color: #111
  }

  .pkg-desc {
    font-size: .8rem;
    color: #666
  }

  .pkg-price {
    font-weight: 700;
    margin-top: 6px
  }

  /* FORM */

  .form {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 14px
  }

  .form input {
    padding: 12px;
    border-radius: 10px;
    border: 1px solid #ddd
  }

  /* CONFIRM */

  .confirm-card {
    background: #f9fafb;
    padding: 16px;
    border-radius: 14px;
    margin: 14px 0;
  }

  .confirm-card .row {
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
    border-bottom: 1px solid #e5e7eb;
  }

  .confirm-card .row:last-child {
    border: none
  }

  /* BUTTON */

  .primary {
    width: 100%;
    margin-top: 10px;
    padding: 12px;
    border: none;
    border-radius: 12px;
    background: #111;
    color: #fff;
  }

  /* SUCCESS */

  .success .check {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: #22c55e;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 26px;
    margin: 0 auto 12px;
  }

  /* MOBILE */

  @media(max-width:768px) {
    .two-col-card {
      grid-template-columns: 1fr
    }
  }

  /* ===============================
 GLOBAL TYPOGRAPHY POLISH
================================ */

  h2 {
    font-size: 1.25rem;
    font-weight: 700;
    margin-bottom: 10px;
  }

  h3 {
    font-size: 1.05rem;
    font-weight: 600;
  }

  p {
    font-size: 0.9rem;
    color: #374151;
  }

  /* ===============================
 TRANSITIONS
================================ */

  .page * {
    transition: background-color .2s ease,
      color .2s ease,
      transform .2s ease,
      box-shadow .2s ease,
      border-color .2s ease;
  }

  /* ===============================
 CARD HOVER ELEVATION
================================ */

  .two-col-card:hover,
  .center-card:hover {
    box-shadow: 0 24px 70px rgba(0, 0, 0, .14);
  }

  /* ===============================
 CALENDAR MICRO INTERACTION
================================ */

  .date {
    border: 1px solid transparent;
  }

  .date:hover {
    transform: scale(1.05);
  }

  .date.active {
    box-shadow: 0 4px 12px rgba(0, 0, 0, .25);
  }

  /* ===============================
 SLOT ACTIVE STATE
================================ */

  .slot:active {
    transform: scale(.97);
  }

  .slot.selected {
    background: #111;
    color: #fff;
    border-color: #111;
  }

  /* ===============================
 PACKAGE HOVER EFFECT
================================ */

  .pkg-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 18px rgba(0, 0, 0, .12);
  }

  /* ===============================
 INPUT FOCUS STYLE
================================ */

  .form input:focus {
    outline: none;
    border-color: #111;
    box-shadow: 0 0 0 2px rgba(17, 24, 39, .15);
  }

  /* ===============================
 BUTTON STATES
================================ */

  .primary:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 6px 14px rgba(0, 0, 0, .25);
  }

  .primary:active {
    transform: scale(.98);
  }

  .primary:disabled {
    background: #9ca3af;
    cursor: not-allowed;
  }

  /* ===============================
 CONFIRM CARD HIGHLIGHT
================================ */

  .confirm-card .row b {
    color: #111827;
  }

  .confirm-card .row span {
    color: #6b7280;
  }

  /* ===============================
 LOADING TEXT
================================ */

  .loading {
    padding: 30px 0;
    text-align: center;
    font-size: .9rem;
    color: #6b7280;
  }

  /* ===============================
 SUCCESS ANIMATION
================================ */

  .success .check {
    animation: pop .4s ease;
  }

  @keyframes pop {
    0% {
      transform: scale(.5);
      opacity: 0
    }

    100% {
      transform: scale(1);
      opacity: 1
    }
  }

  /* ===============================
 FADE BETWEEN STEPS
================================ */

  .center-card,
  .two-col-card {
    animation: fadeIn .25s ease;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px)
    }

    to {
      opacity: 1;
      transform: none
    }
  }

  /* ===============================
 MOBILE TOUCH IMPROVEMENT
================================ */

  @media(max-width:480px) {

    h2 {
      font-size: 1.15rem;
    }

    .slot {
      padding: 10px;
      font-size: .85rem;
    }

    .pkg-card {
      padding: 12px;
    }

    .primary {
      padding: 11px;
      font-size: .9rem;
    }

  }

  /* ===============================
 HIGH DPI SCREENS
================================ */

  @media(min-resolution:2dppx) {

    .two-col-card,
    .center-card {
      box-shadow: 0 16px 50px rgba(0, 0, 0, .10);
    }
  }

  /* ===============================
 OPTIONAL BACK BUTTON STYLE
================================ */

  .back-btn {
    background: none;
    border: none;
    color: #6b7280;
    font-size: .85rem;
    margin-bottom: 10px;
    cursor: pointer;
  }

  .back-btn:hover {
    color: #111;
  }

  /* ===============================
 SUMMARY ROW SEPARATORS
================================ */

  .confirm-card .row:not(:last-child) {
    border-bottom: 1px dashed #e5e7eb;
  }

  /* ===============================
 SUBTLE GRADIENT HEADER (OPTIONAL)
================================ */

  .section-title {
    background: linear-gradient(90deg, #111, #4b5563);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  /* ===============================
 CALENDAR NAV BUTTONS
================================ */

  .cal-header button {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 1px solid #e5e7eb;
    background: #ffffff;
    color: #111827;
    font-size: 18px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 2px 6px rgba(0, 0, 0, .08);
    transition: all .2s ease;
  }

  .cal-header button:hover {
    background: #111827;
    color: #ffffff;
    border-color: #111827;
    transform: translateY(-1px);
  }

  .cal-header button:active {
    transform: scale(.95);
  }

  .cal-header button:disabled {
    opacity: .4;
    cursor: not-allowed;
    box-shadow: none;
  }

  /* ===============================
 VERTICAL SLOT LIST
================================ */

  .slot-grid {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 14px;
    max-height: 420px;
    overflow-y: auto;
  }

  /* SLOT CARD */

  .slot {
    width: 100%;
    padding: 14px;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    background: #ffffff;
    font-size: .9rem;
    font-weight: 500;
    text-align: center;
    cursor: pointer;
    transition: .2s ease;
  }

  /* Hover */

  .slot:hover {
    background: #111827;
    color: #ffffff;
    border-color: #111827;
    transform: translateY(-1px);
  }

  /* Active / Selected */

  .slot.active {
    background: #111827;
    color: #ffffff;
    border-color: #111827;
    box-shadow: 0 6px 18px rgba(0, 0, 0, .25);
  }

  /* Click Feedback */

  .slot:active {
    transform: scale(.97);
  }

  /* ===============================
 PACKAGE ACTIVE TEXT COLOR FIX
================================ */

  .pkg-card.active h4,
  .pkg-card.active p,
  .pkg-card.active .pkg-desc,
  .pkg-card.active .pkg-price {
    color: #ffffff !important;
  }

  /* ============================
 DYNAMIC FORM FIELD FIX
============================ */

  .form-field input,
  .form-field textarea,
  .form-field select {
    width: 100%;
    padding: 12px;
    border-radius: 10px;
    border: 1px solid #ddd;
    font-size: 0.9rem;
    box-sizing: border-box;
  }

  .form-field textarea {
    resize: vertical;
    min-height: 80px;
  }

  .date.disabled {
    opacity: 0.35;
    pointer-events: none;
    background: #f3f4f6;
  }
  /* ============================
 SLOT EMPTY PLACEHOLDER
============================ */

.slot-empty{
  height:260px;
  border-radius:16px;
  background:#f9fafb;
  border:1px dashed #e5e7eb;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  text-align:center;
  padding:20px;
}

.slot-empty-icon{
  font-size:40px;
  margin-bottom:10px;
}

.slot-empty-title{
  font-size:0.95rem;
  font-weight:600;
  color:#111827;
}

.slot-empty-sub{
  font-size:0.85rem;
  color:#6b7280;
  margin-top:4px;
}
/* ============================
 SLOT LOADING STATE
============================ */

.slot-loading{
  height:260px;
  border-radius:16px;
  background:#f9fafb;
  border:1px dashed #e5e7eb;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  gap:10px;
  text-align:center;
}

.slot-loading i{
  font-size:38px;
  color:#111827;
}

.slot-loading p{
  font-size:0.85rem;
  color:#6b7280;
}
/* =========================
 CONFIRM BOOKING UI
========================= */

.confirm-card{
  background:#f9fafb;
  padding:18px;
  border-radius:16px;
  margin:16px 0;
  border:1px solid #e5e7eb;
}

.confirm-row{
  display:flex;
  justify-content:space-between;
  align-items:center;
  padding:10px 0;
  border-bottom:1px dashed #e5e7eb;
}

.confirm-row:last-child{
  border-bottom:none;
}

.confirm-row span{
  font-size:0.85rem;
  color:#6b7280;
}

.confirm-row b{
  font-size:0.9rem;
  font-weight:600;
  color:#111827;
}

/* Amount Highlight */

.confirm-row.highlight{
  background:#111827;
  padding:12px;
  border-radius:12px;
  margin-top:12px;
  border:none;
}

.confirm-row.highlight span,
.confirm-row.highlight b{
  color:#ffffff;
  font-size:0.95rem;
  font-weight:700;
}
.tz-select{
  width:100%;
  padding:10px;
  border-radius:10px;
  border:1px solid #e5e7eb;
  margin:6px 0 10px;
  font-size:.85rem;
  background:#fff;
}
/* ===============================
PAYMENT MODAL
================================ */

.payment-overlay{
  position:fixed;
  inset:0;
  background:rgba(0,0,0,.45);
  display:flex;
  align-items:center;
  justify-content:center;
  z-index:1000;
  animation:fadeIn .2s ease;
}

.payment-modal{
  width:100%;
  max-width:420px;
  background:#fff;
  padding:26px;
  border-radius:18px;
  box-shadow:0 20px 60px rgba(0,0,0,.25);
  animation:fadeIn .25s ease;
}

.payment-modal h3{
  text-align:center;
  font-size:1.1rem;
  margin-bottom:18px;
}

.pay-options{
  display:flex;
  flex-direction:column;
  gap:14px;
}

.pay-card{
  display:flex;
  align-items:center;
  gap:14px;
  padding:14px;
  border-radius:14px;
  border:1px solid #e5e7eb;
  cursor:pointer;
  transition:.2s ease;
}

.pay-card:hover{
  transform:translateY(-2px);
  box-shadow:0 8px 20px rgba(0,0,0,.12);
}

.pay-logo{
  width:42px;
  height:42px;
  border-radius:12px;
  display:flex;
  align-items:center;
  justify-content:center;
  font-weight:700;
  color:#fff;
  font-size:18px;
}

/* PAYPAL BRAND */
.paypal .pay-logo{
  background:#003087;
}

.paypal:hover{
  border-color:#003087;
}

/* STRIPE BRAND */
.stripe .pay-logo{
  background:#635bff;
}

.stripe:hover{
  border-color:#635bff;
}

.pay-info b{
  font-size:.95rem;
}

.pay-info p{
  font-size:.8rem;
  color:#6b7280;
}

.cancel-btn{
  margin-top:18px;
  width:100%;
  padding:10px;
  border:none;
  border-radius:12px;
  background:#f3f4f6;
  cursor:pointer;
}

.cancel-btn:hover{
  background:#e5e7eb;
}
</style>